<template>
  <v-autocomplete
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.eixosIds"
    item-text="nome"
    item-name="nome"
    item-value="eixoId"
    :items="eixos"
    label=""
    placeholder="Eixo"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    multiple
    clearable
    :rules="rules"
    chips
    closable-chips
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.eixosIds.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.eixosIds.length - maxDisplay }} eixos)</span
      >
    </template>

    <template slot="no-data"> Nenhum Eixo retornado </template>
  </v-autocomplete>
</template>

<script>
import { eixoAPI } from "@/modules/eixo/API/eixoAPI";
import { mapActions } from "vuex";

export default {
  name: "AppEixoCombobox",
  props: {
    rules: {
      type: Array,
      default: () => {
        [];
      },
    },
    filter: {
      type: Object,
      default: () => {
        ({ eixosIds: [] });
      },
    },
    payloadEixos: {
      type: Array,
      default: () => {
        [];
      },
    },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    if (!this.payloadEixos.length) this.loadEixos();
    else this.eixos = this.payloadEixos;
  },
  computed: {
    likesAll() {
      return this.filter.eixosIds.length === this.eixos.length;
    },
    likesSome() {
      return this.filter.eixosIds.length > 0 && !this.eixos;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    loadEixos() {
      eixoAPI
        .list()
        .then((resp) => {
          this.eixos = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter Eixos");
        });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.eixosIds = [];
          this.$emit("onChange", this.filter.eixosIds);
        } else {
          this.filter.eixosIds = this.eixos.slice();
          this.$emit("onChange", this.filter.eixosIds);
        }
      });
    },
  },
  data() {
    return {
      maxDisplay: 2,
      eixos: [],
    };
  },
};
</script>

<style scoped>
.tema-eixo-combo {
  padding: 0 24px 20px;
}
</style>
